export const ASSET_CLASSES = {
  CASH: "เงินสดและรายการเทียบเท่า",
  COMMODITY: "สินค้าโภคภัณฑ์",
  ADR: "หนังสือแสดงสิทธิ์ ADR",
  ETF: "กองทุน ETF",
  EQUITY: "หุ้นสามัญ",
};

export const MONTH_OPTIONS = [
  { label: "Jan", value: "1" }, { label: "Feb", value: "2" },
  { label: "Mar", value: "3" }, { label: "Apr", value: "4" },
  { label: "May", value: "5" }, { label: "Jun", value: "6" },
  { label: "Jul", value: "7" }, { label: "Aug", value: "8" },
  { label: "Sep", value: "9" }, { label: "Oct", value: "10" },
  { label: "Nov", value: "11" }, { label: "Dec", value: "12" },
];

export const ACTIVE_COLOR_LIGHT = "#132B43";
export const INACTIVE_COLOR_LIGHT = "#e2e8f0";
export const ACTIVE_COLOR_DARK = "#60a5fa";
export const INACTIVE_COLOR_DARK = "#334155";
export const PALETTE_LIGHT = ["#132B43", "#1e456d", "#296098", "#387dc4", "#94a3b8"];
export const PALETTE_DARK = ["#60a5fa", "#3b82f6", "#2563eb", "#1d4ed8", "#475569"];

export const TRANSLATIONS = {
  EN: {
    summary: "Summary", allocation: "Allocation", insights: "Insights",
    trades: "Trades", dividends: "Dividends", settled: "Settled",
    capital: "Capital", holdings: "Holdings", portfolio_value: "Portfolio Value",
    cost_basis: "Cost Basis", unrealized_pl: "Unrealized P/L",
    realized_gain: "Realized Gain", total_dividends: "Total Dividends",
    all_time_profit: "All-Time Profit", search_placeholder: "Search Symbol...",
    market_open: "OPEN", market_closed: "CLOSED", upgrade_vip: "Upgrade VIP",
    fundamental: "Fundamentals", xd: "XD.Calendar", investment: "Investment", pivot: "Pivot Levels", tax_calculator: "Tax Estimate",
    tax_strategy: "Tax Strategy", app_update: "App Update", news: "News", all: "ALL", 
    total_deposit: "Total Deposit", total_withdrawal: "Total Withdrawal",
    net_balance: "Net Balance", gross_dividend: "Gross Dividend",
    tax_wht: "Tax WHT 15%", net_received: "Net Received", realized_total: "Realized Total",
    win_rate: "Win Rate", trades_settled: "Trades Settled",
    live_asset_holdings: "Live Asset Holdings", realtime_data_subtitle: "XFOLYO Portfolio Tracker • Market Data",
    export: "Export", no_assets_found: "No Assets Found", stock_daily: "Stock / Daily",
    avg_price: "Avg Price", live_price: "Live Price", market_value: "Market Value",
    upcoming_xd: "Upcoming XD Calendar", forecasting_system: "XFOLYO Portfolio Tracker • Forecasting System",
    all_holdings: "ALL HOLDINGS", symbol_status: "Symbol", holdings_shares: "Holdings (Shares)",
    div_rate: "Div. Rate", ex_date: "Ex-Date", gross_total: "Gross Total",
    wht_15: "WHT (15%)", net_usd: "Net (USD)", net_thb: "Net (THB)",
    no_dividend_data: "No Dividend Data Detected", ed_passed: "ED-Passed",
    transactions: "Transactions",
    years: "Years",
    months: "Months",
    add_trade: "Add Trade",
    action: "Action",
    date_time: "Date & Time",
    stock: "Stock",
    type: "Type",
    price: "Price",
    units: "Units",
    fx_rate: "FX Rate",
    comm: "Comm.",
    vat: "VAT",
    sec_fee: "SEC Fee",
    taf_fee: "TAF Fee",
    no_transactions_found: "No transactions found",capital_logs: "Capital Logs",
    new_entry: "New Entry",
    date: "Date",
    amount_usd: "Amount (USD)",
    no_capital_records: "No capital records found",
    settled_deals: "Settled Deals",
    profit_usd: "Profit (USD)",
    profit_thb: "Profit (THB)",
    no_realized_records: "No realized profit records found",
    live_data: "Live Data",
    updated: "Updated",
    market_open: "Open",
    market_closed: "Closed",
    portfolio_value: "Portfolio Value",
    all_time_profit: "All-Time Profit",
    net_capital: "Net Capital",
    cost_basis: "Cost Basis",
    unrealized_pl: "Unrealized P/L",
    realized_gain: "Realized Gain",
    total_dividends: "Total Dividends",
    dividend_logs: "Dividend Logs",
    record: "Record",
    gross: "Gross",
    wht: "WHT",
    net: "Net",
    no_dividend_records: "No dividend records found",
    investment_analysis: "Investment Analysis",
    tech_and_fundamentals: "Technical & Fundamentals",
    symbol_placeholder: "Symbol",
    loading_chart: "Loading Chart...",
    loading_financials: "Loading Financials...",
    key_financial_ratios: "💡 Key Financial Ratios (Quick Guide)",
    import_data: "Import",
    no_asset_data: "No asset data available",
    all_assets: "All Assets",
    invested_amount: "Invested",
    pl: "P/L",
  },
  TH: {
    summary: "สรุปพอร์ต", allocation: "สัดส่วน", insights: "บทความ",
    trades: "การซื้อขาย", dividends: "ปันผล", settled: "ขายแล้ว",
    capital: "เงินทุน", holdings: "หุ้นที่ถือ", portfolio_value: "มูลค่าพอร์ตสุทธิ",
    cost_basis: "เงินต้นรวม", unrealized_pl: "กำไร/ขาดทุน",
    realized_gain: "กำไรที่ขายแล้ว", total_dividends: "ปันผลรับสุทธิ",
    all_time_profit: "กำไรสุทธิรวม", search_placeholder: "ค้นหาชื่อหุ้น...",
    market_open: "เปิด", market_closed: "ปิด", upgrade_vip: "อัปเกรด VIP",
    fundamental: "ข้อมูลพื้นฐาน", xd: "ปฏิทินปันผล", investment: "การลงทุน", pivot: "แนวรับ–แนวต้าน", tax_calculator: "ประมาณการภาษี",
    tax_strategy: "วางแผนภาษี", app_update: "อัปเดตแอป", news: "ข่าวสาร", 
    all: "ทั้งหมด", total_deposit: "ยอดฝากรวม", total_withdrawal: "ยอดถอนรวม",
    net_balance: "ยอดทุนสุทธิ", gross_dividend: "ปันผลรวม", tax_wht: "หักภาษี 15%",
    net_received: "ปันผลรับสุทธิ", realized_total: "กำไรที่รับรู้แล้ว",
    win_rate: "อัตราความสำเร็จ", trades_settled: "รายการที่ปิดแล้ว",
    live_asset_holdings: "สินทรัพย์ที่ถือครอง", realtime_data_subtitle: "XFOLYO Portfolio Tracker • ข้อมูลตลาด",
    export: "ส่งออกข้อมูล", no_assets_found: "ไม่พบสินทรัพย์ในพอร์ต", stock_daily: "หุ้น / รายวัน",
    avg_price: "ราคาเฉลี่ย", live_price: "ราคาปัจจุบัน", market_value: "มูลค่าตลาด",
    upcoming_xd: "ปฏิทินปันผลล่วงหน้า", forecasting_system: "XFOLYO Portfolio Tracker • ระบบพยากรณ์กระแสเงินสด",
    all_holdings: "ทุกสินทรัพย์", symbol_status: "หุ้น", holdings_shares: "จำนวนหุ้น",
    div_rate: "เรทปันผล", ex_date: "วันที่ XD", gross_total: "ปันผลรวม",
    wht_15: "หักภาษี 15%", net_usd: "สุทธิ (USD)", net_thb: "สุทธิ (THB)",
    no_dividend_data: "ไม่พบข้อมูลการจ่ายปันผล", ed_passed: "ผ่านวัน XD แล้ว",
    transactions: "ประวัติการซื้อขาย",
    years: "ปี",
    months: "เดือน",
    add_trade: "เพิ่มรายการ",
    action: "จัดการ",
    date_time: "วันและเวลา",
    stock: "หุ้น",
    type: "ประเภท",
    price: "ราคา",
    units: "จำนวนหุ้น",
    fx_rate: "อัตราแลกเปลี่ยน",
    comm: "ค่าคอม",
    vat: "VAT",
    sec_fee: "ค่าธรรมเนียม SEC",
    taf_fee: "ค่าธรรมเนียม TAF",
    no_transactions_found: "ไม่พบประวัติการซื้อขาย",
    capital_logs: "ประวัติเงินทุน",
    new_entry: "เพิ่มรายการ",
    date: "วันที่",
    amount_usd: "จำนวนเงิน (USD)",
    no_capital_records: "ไม่พบประวัติเงินทุน",
    settled_deals: "รายการที่ปิดแล้ว",
    profit_usd: "กำไร (USD)",
    profit_thb: "กำไร (THB)",
    no_realized_records: "ไม่พบประวัติกำไรที่รับรู้แล้ว",
    live_data: "ข้อมูลเรียลไทม์",
    updated: "อัปเดตล่าสุด",
    market_open: "เปิด",
    market_closed: "ปิด",
    portfolio_value: "มูลค่าพอร์ตรวม",
    all_time_profit: "กำไร/ขาดทุน (All-Time)",
    net_capital: "เงินทุนสุทธิ",
    cost_basis: "ต้นทุนรวม",
    unrealized_pl: "กำไรยังไม่รับรู้",
    realized_gain: "กำไรที่รับรู้แล้ว",
    total_dividends: "ปันผลรับรวม",
    dividend_logs: "ประวัติเงินปันผล",
    record: "บันทึกปันผล",
    gross: "ปันผลรวม",
    wht: "หักภาษี",
    net: "สุทธิ",
    no_dividend_records: "ไม่พบประวัติการรับปันผล",
    investment_analysis: "วิเคราะห์การลงทุน",
    tech_and_fundamentals: "ปัจจัยทางเทคนิคและพื้นฐาน",
    symbol_placeholder: "ชื่อหุ้น",
    loading_chart: "กำลังโหลดกราฟ...",
    loading_financials: "กำลังโหลดงบการเงิน...",
    key_financial_ratios: "💡 คู่มืออ่านงบการเงินฉบับย่อ",
    import_data: "นำเข้าข้อมูล",
    no_asset_data: "ไม่พบข้อมูลสินทรัพย์",
    all_assets: "สินทรัพย์ทั้งหมด",
    invested_amount: "ยอดลงทุน",
    pl: "กำไร/ขาดทุน",
  }
};
